/* eslint new-cap: "off" */
define(['components/utilities/utilities', 'components/pubsub/pubsub', 'components/cookie/cookie', 'libs/velocity'], function (utils, pubsub, cookie, Velocity) {
	'use strict';

	/**
	 * Compare list
	 * A plugin that adds the compare list functionality.
	 * @version 1.0.0
	 * @exports compareList
	 */
	var compareList = {

		/** Placeholder for base DOM element. */
		el: null,

		/** DOM node containing list length count. */
		counterNode: document.getElementById('my-compare-list-counter'),

		/** DOM node for the compare button. */
		compareButton: document.getElementById('compare-button'),

		/** DOM node for the open comparelist button. */
		openCompareButton: document.getElementById('my-compare-list-btn'),

		/** Placeholder string which will contain the default (base) href of the compare button. */
		compareButtonDefaultHref: '',

		/** String containing the name-attribute of the checkboxes. */
		checkboxNameAttr: document.querySelector('[data-type="compare-list-checkbox-nojs"]').getAttribute('name'),

		/** The list (array) which will contain the selected items for comparison. */
		list: [],

		/** Will contain the name of the cookie for this comparison list. */
		cookieName: null,

		/** Lifetime of the cookie in days. */
		cookieLifeLength: 365,

		/** String containing text which might have translations made from the masterpage. */
		removeFromList: mainConfig.i18n && mainConfig.i18n.removeFromList || 'Ta bort från listan',

		/** Animation time in milliseconds. */
		listAnimationTime: 800,


		/**
		 * The initialization function for this module.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		init: function (el) {
			this.el = el;
			this.cookieName = this.el.getAttribute('data-cookiename');
			this.compareButtonDefaultHref = this.compareButton.href;

			this._initEvents();
			this._initSubscriptions();
			this._getItemsFromCookie();
			this._updateCompareButton();
		},


		/**
		 * Loads values from the cookie and add them to the list.
		 * @see {@link module:compareList._addToList}
		 * @private
		 */
		_getItemsFromCookie: function () {
			if (this.cookieName !== null) {
				var cookieItems = null;

				try {
					cookieItems = JSON.parse(decodeURIComponent(cookie.getCookie(this.cookieName)));
				} catch (e) {}

				if (cookieItems !== null && cookieItems !== '') {
					for (var i = 0; i < cookieItems.length; i++) {
						if (cookieItems[i].id !== undefined && cookieItems[i].name !== undefined && cookieItems[i].url !== undefined) {
							this._addToList(cookieItems[i].id, cookieItems[i].name, cookieItems[i].url);
						}
					}
				}
			}
		},


		/**
		 * Adds a new item to the list.
		 * @param {Number} id - The id of the item to be added.
		 * @param {String} name - The name of the item to be added.
		 * @param {String} url - The url of the item to be added.
		 * @see {@link module:compareList._listIsUpdated}
		 * @private
		 */
		_addToList: function (id, name, url) {
			var newItem = '<li id="list-item-' + id + '"><a href="' + url + '">' + name + '</a> <a href="#" data-id="' + id + '" class="close-btn" data-type="compare-list-remove"><span class="icon icon-close" aria-hidden="true"></span><span class="is-visuallyhidden">' + this.removeFromList + '</span></a></li>';

			this.list.push({ id: id, name: name, url: url });
			this.el.insertAdjacentHTML('BeforeEnd', newItem);
			document.getElementById('compare-checkbox-' + id).checked = true;
			this._listIsUpdated();
		},


		/**
		 * Removes an item from the list.
		 * @param {Number} id - The id of the item to be removed.
		 * @see {@link module:compareList._listIsUpdated}
		 * @private
		 */
		_removeFromList: function (id) {
			var removeItem = document.getElementById('list-item-' + id);

			if (removeItem !== null) {
				this._animateRemoveFromList();

				if (removeItem.remove) {
					removeItem.remove();
				} else {
					removeItem.parentNode.removeChild(removeItem);
				}

				for (var i = 0; i < this.list.length; i++) {
					if (this.list[i].id === id) {
						this.list.splice(i, 1);
						break;
					}
				}
				document.getElementById('compare-checkbox-' + id).checked = false;
				this._listIsUpdated();
			}
		},


		/**
		 * Function that gets called when the list has been updated.
		 * It stores the new list to the cookie, updates the counter, re-init events and compare button.
		 * @see {@link module:compareList._initEvents}
		 * @see {@link module:compareList._updateCompareButton}
		 * @private
		 */
		_listIsUpdated: function () {
			cookie.setCookie(this.cookieName, encodeURIComponent(JSON.stringify(this.list)), this.cookieLifeLength);
			this.counterNode.innerHTML = this.list.length;
			this._initEvents();
			this._updateCompareButton();
		},


		/**
		 * Checks the checkboxes on the pages for which items are in the list.
		 * @private
		 */
		_checkSelectedItems: function () {
			for (var i = 0; i < this.list.length; i++) {
				var cbx = document.getElementById('compare-checkbox-' + this.list[i].id);
				if (cbx !== null && cbx.checked === false) {
					cbx.checked = true;
				}
			}
		},


		/**
		 * Updates the compare button.
		 * Sets it to an inactive state if the list contains no items.
		 * Update the href if the list contains items.
		 * @private
		 */
		_updateCompareButton: function () {
			var newHref = '';

			if (this.list.length === 0) {
				utils.addClass(this.compareButton, 'is-inactive');
				newHref = '#';
			} else {
				newHref = this.compareButtonDefaultHref;

				for (var i = 0; i < this.list.length; i++) {
					if (i === 0 && newHref.indexOf('?') === -1) {
						newHref += '?' + this.checkboxNameAttr + '=' + this.list[i].id;
					} else {
						newHref += '&' + this.checkboxNameAttr + '=' + this.list[i].id;
					}
				}
				utils.removeClass(this.compareButton, 'is-inactive');
			}

			this.compareButton.href = newHref;
		},


		/**
		 * Animates an item when it's added to the compare list.
		 * @private
		 */
		_animateAddToList: function (el) {
			var that = this,
				id = el.value,
				headerNode = document.getElementById('compare-header-' + id),
				headerNodeOffset = headerNode.getBoundingClientRect(),
				viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
				aniHeaderNode;

			if (headerNode !== null) {
				aniHeaderNode = headerNode.querySelector('h1').cloneNode(true);
				aniHeaderNode.style.position = 'fixed';
				aniHeaderNode.style.top = headerNodeOffset.top + 'px';
				aniHeaderNode.style.left = headerNodeOffset.left + 'px';
				aniHeaderNode.style.zIndex = 880;
				headerNode.appendChild(aniHeaderNode);

				Velocity(aniHeaderNode,
					{
						top: (viewportHeight - 60) + 'px',
						left: '45%',
						scale: 0.8
					},
					{
						duration: this.listAnimationTime,
						complete: function (elements) {
							if (elements[0].remove) {
								elements[0].remove();
							} else {
								elements[0].parentNode.removeChild(elements[0]);
							}

							// Animate the compare list button.
							utils.addClass(that.openCompareButton, 'has-new-content');
							setTimeout(function () {
								utils.removeClass(that.openCompareButton, 'has-new-content');
							}, 200);
						}
					}
				);
			}
		},


		/**
		 * Animates the compare-list button when an item is removed.
		 * This script only adds/removes classes, the actual animation is css-based.
		 * @private
		 */
		_animateRemoveFromList: function () {
			var that = this;

			utils.addClass(this.openCompareButton, 'has-removed-content');
			setTimeout(function () {
				utils.removeClass(that.openCompareButton, 'has-removed-content');
			}, 200);
		},


		/**
		 * Initiates events.
		 * @private
		 */
		_initEvents: function () {
			var that = this;

			utils.forEachElement('[data-type="compare-list-checkbox"]', function (el) {
				if (el.getAttribute('data-initiated') !== null) {
					return false;
				}

				el.setAttribute('data-initiated', true);

				utils.addEventListener(el, 'change', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					if (el.checked === true) {
						setTimeout(function () {
							that._addToList(el.value, el.getAttribute('data-item-name'), el.getAttribute('data-item-url'));
						}, that.listAnimationTime);
						that._animateAddToList(el);
					} else {
						that._removeFromList(el.value);
					}
				});
			});

			utils.forEachElement('[data-type="compare-list-remove"]', function (el) {
				if (el.getAttribute('data-initiated') !== null) {
					return false;
				}

				el.setAttribute('data-initiated', true);

				utils.addEventListener(el, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					var id = el.getAttribute('data-id');

					if (id !== null) {
						that._removeFromList(id);
					}
				});
			});
		},


		/**
		 * Initiates subscriptions.
		 * Updates events and state after the html of the search-list has been updated.
		 * @see {@link module:compareList._checkSelectedItems}
		 * @see {@link module:compareList._initEvents}
		 * @private
		 */
		_initSubscriptions: function () {
			var that = this;

			pubsub.subscribe('/ajaxForm/list/updated', function () {
				that._checkSelectedItems();
				that._initEvents();
			});
		}
	};


	return compareList;
});


//////////////////
// WEBPACK FOOTER
// ./components/compareList/compareList.js
// module id = 61
// module chunks = 14